import { Dataset } from '../../../types/types';
import { datasetIncludesPeerset } from './datasetIncludesPeerset';

// Genuine peerset switch only: the loaded dataset must be the route we are leaving,
// otherwise a stale `dataset` (e.g. after a form route with no datasetId) is misread
// as a same-peerset switch and the filter fetch gets skipped.
export const isPeersetSwitch = (
  dataset: Dataset | undefined,
  newDatasetId: string | undefined,
  prevDatasetId: string | undefined
): boolean => {
  if (!dataset || dataset.datasetId !== prevDatasetId) {
    return false;
  }
  return datasetIncludesPeerset(dataset, newDatasetId);
};
